import theme from 'theme';
import { CircleBox } from 'components/styles_components/box';

const resolveColors = (count, color) => {
  if (count > 0) {
    return {
      bg: theme.palette[color].main,
      fg: theme.palette[color].contrastText,
    };
  }
  return {
    bg: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300],
    fg: theme.palette.text.secondary,
  };
};

const CountCircle = ({ count = 0, color = 'warning', size = 32 }) => {
  const { bg, fg } = resolveColors(count, color);

  return (
    <CircleBox $size={size} $bg={bg} $fg={fg}>
      {count}
    </CircleBox>
  );
};

export default CountCircle;
